import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { clientListingPath } from "helpers/navigationHelper";
import LoadingButton from "../LoadingButton";
import { successMessageToast } from "helpers/common";
import { useSubmitReportMutation } from "store/services/clients/assessmentTreatmentPlan";

const SaveForLaterBtn = ({ assessmentAssignedId, clientType, isLoading=false , setSaveLater}) => {
  const navigate = useNavigate();

  const [submitReport, { isLoading:isLoadingsubmit }] = useSubmitReportMutation();

  const handleSaveLater = async () => {
    try {
      setSaveLater(true)
      const payload = {
        assessmentAssignedId,
        data: {
          save_for_later: "yes",
        },
        clientType
      }
      
      await submitReport(payload).unwrap();

      successMessageToast("Record updated successfully.")
      navigate(clientListingPath(clientType));
    } catch(err) {
      setSaveLater(false)
      console.error("Error in save for later", err);
    }finally{
      setSaveLater(false)
    }
  };

  return (
    <LoadingButton
      style={{
        background: "rgb(69, 163, 165)",
        borderColor: "rgb(69, 163, 165)",
      }}
      onClick={handleSaveLater}
      className="d-flex align-items-center justify-content-center commonBtn fw-sbold"
      type="button"
      isLoading={isLoadingsubmit}
      disabled={isLoading}
    >
      Save For Later
    </LoadingButton>
  )
}

export default SaveForLaterBtn;